import { render } from "./canjiandanwei.vue?vue&type=template&id=2257af08&scoped=true&ts=true"
import script from "./canjiandanwei.vue?vue&type=script&lang=ts"
export * from "./canjiandanwei.vue?vue&type=script&lang=ts"

import "./canjiandanwei.vue?vue&type=style&index=0&id=2257af08&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2257af08"]])

export default __exports__